module.exports = __webpack_public_path__ + "static/media/logosasccm.445c194c.png";